import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellFloat } from '../../table/cells/CellFloat';

export const ModelCellFloatBase = (props: TableInheritedProps) => (
  <CellFloat {...props} />
);

export const ModelCellFloat = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellFloat', ModelCellFloatBase, props);
